/** Navigation model; kept out of the component file so fast refresh works. */
import {
  BarChart3,
  BellRing,
  CalendarClock,
  ChevronsUpDown,
  Contact,
  Cog,
  GitBranch,
  KeyRound,
  LayoutDashboard,
  type LucideIcon,
  Plug,
  Route,
  Send,
  UserCog,
  Users,
  Wrench,
} from 'lucide-react';
import type { Role } from '../lib/schemas.js';

export interface NavItem {
  to: string;
  label: string;
  icon: LucideIcon;
  /** Minimum role needed to see the entry at all. */
  minRole?: Role;
  /** Shown in the phone bottom bar. */
  primary?: boolean;
}

export interface NavSection {
  title: string;
  items: NavItem[];
}

export const NAV_SECTIONS: NavSection[] = [
  {
    title: 'Operate',
    items: [
      { to: '/dashboard', label: 'Dashboard', icon: LayoutDashboard, primary: true },
      { to: '/alarms', label: 'Alarms', icon: BellRing, primary: true },
      { to: '/schedules', label: 'Schedules', icon: CalendarClock, primary: true },
      { to: '/maintenance', label: 'Maintenance', icon: Wrench },
      { to: '/reports', label: 'Reports', icon: BarChart3 },
    ],
  },
  {
    title: 'Route',
    items: [
      { to: '/rules', label: 'Processing rules', icon: GitBranch, minRole: 'operator' },
      { to: '/policies', label: 'Notification policies', icon: Route, minRole: 'operator' },
      { to: '/escalations', label: 'Escalations', icon: ChevronsUpDown, minRole: 'operator' },
    ],
  },
  {
    title: 'Connect',
    items: [
      { to: '/integrations', label: 'Integrations', icon: Plug, primary: true },
      { to: '/outbound', label: 'Outbound', icon: Send },
      { to: '/contacts', label: 'Contacts', icon: Contact },
    ],
  },
  {
    title: 'Administer',
    items: [
      { to: '/teams', label: 'Teams', icon: Users },
      { to: '/users', label: 'Users', icon: UserCog },
      { to: '/api-keys', label: 'API keys', icon: KeyRound, minRole: 'admin' },
      { to: '/settings', label: 'Settings', icon: Cog },
    ],
  },
];

/** Flat list, used by the command palette and the mobile bottom bar. */
export const NAV_ITEMS: NavItem[] = NAV_SECTIONS.flatMap((section) => section.items);

export const SIDEBAR_STORAGE_KEY = 'vam.sidebar.collapsed';
